import { createAction } from '@reduxjs/toolkit';

import {
  INCREMENT_REQUEST_COUNTER,
  DECREMENT_REQUEST_COUNTER,
  RESET_REQUEST_COUNTER,
  PUSH_SNACKBAR,
  POP_SNACKBAR,
  APP_INIT,
  WINDOW_RESIZE,
  SITE_INFO_HEIGHT_RECEIVED,
  NEW_CONSULTATION,
  APP_LAYOUT_CHANGE,
} from './constants';

export const appInit = createAction(APP_INIT, ({ browserSupport }) => ({
  payload: {
    browserSupport,
  },
}));

export function siteInfoHeightReceived({ height }) {
  return {
    type: SITE_INFO_HEIGHT_RECEIVED,
    payload: {
      height,
    },
  };
}

export function windowResize() {
  return {
    type: WINDOW_RESIZE,
  };
}

export function incrementRequestCounter({ type }) {
  return {
    type: INCREMENT_REQUEST_COUNTER,
    payload: {
      type,
    },
  };
}

export function decrementRequestCounter({ type }) {
  return {
    type: DECREMENT_REQUEST_COUNTER,
    payload: {
      type,
    },
  };
}

export function resetRequestCounter() {
  return {
    type: RESET_REQUEST_COUNTER,
  };
}

export function pushSnackbar({ message, variant, link = null, autoHideDuration = null }) {
  return {
    type: PUSH_SNACKBAR,
    payload: {
      message,
      variant,
      link,
      autoHideDuration,
    },
  };
}

export function popSnackbar() {
  return {
    type: POP_SNACKBAR,
  };
}

export function newConsultation({ id }) {
  return {
    type: NEW_CONSULTATION,
    payload: {
      id,
    },
  };
}

export function appLayoutChange({ isSmall }) {
  return {
    type: APP_LAYOUT_CHANGE,
    payload: {
      isSmall,
    },
  };
}
